import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import Sidebar from "./Sidebar/Sidebar";
import styling from "./Dashboard.module.css";
import Navbar from "./Navbar/Navbar";

import Home from "./Content/Home/Home";
import AddItem from "./Content/AddItem/AddItem";
import AddSuppliers from "./Content/AddSuppliers/AddSuppliers";
import MyStocks from "./Content/MyStocks/MyStocks";
import PurchaseItem from "./Content/PurchaseItem/PurchaseItem";
import SellItem from "./Content/SellItem/SellItem";
import Registration from "../RegisterShop/Registration/Registration";
import Customers from "./Content/Customers/Customers";
// import { useEffect } from "react";
// import { notify, ToastContainer } from "../Notify/Notify";

import AddChannel from "./AddChannels/AddChannels";
// import { useEffect } from "react";

function Dashboard() {
  let shopDetails = useSelector((state) => state.shopDetails);
  let loggedIn = useSelector((state) => state.isLogged);
  let [activeStatus, setActiveStatus] = useState(() => {
    const saved = localStorage.getItem("activeStatus");
    return saved || "Home"; // fallback
  });
  let [showSidebar, setShowSidebar] = useState(true);
  let [showAddChannel, setShowAddChannel] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window.innerWidth < 780) {
      setShowSidebar(false);
    }
  }, []);
  useEffect(() => {
    if (showSidebar && window?.innerWidth < 780) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showSidebar]);

  useEffect(() => {
    // When Redux updates, stop loading
    if (loggedIn !== undefined && shopDetails !== undefined) {
      setLoading(false);
    }
  }, [shopDetails, loggedIn]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (loggedIn && Object.keys(shopDetails).length === 0) {
    return <Redirect to="/registerOptions" />;
  }
  if (!loggedIn) {
    return <Redirect to="/signin" />;
  }
  console.log("shopDetails", shopDetails);
  let toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const componentMap = {
    AddItem,
    AddSuppliers,
    MyStocks,
    PurchaseItem,
    SellItem,
    Registration,
    Customers,
    Home,
  };

  const ActiveComponent = componentMap[activeStatus] || Home;

  function changeComponent(key) {
    localStorage.setItem("activeStatus", key || "Home");
    setActiveStatus(key || "Home");
    if (window.innerWidth < 780) {
      toggleSidebar();
    }
  }
  function toggleAddChannel() {
    setShowAddChannel(!showAddChannel);
  }

  return (
    <>
      <div className={styling.Dashboard}>
        {showSidebar ? (
          <div className={styling.sidebarSection}>
            <Sidebar
              showAddChannel={() => toggleAddChannel()}
              toggleComponent={changeComponent}
              activeStatus={activeStatus}
              toggleSidebar={toggleSidebar}
            />
          </div>
        ) : null}
        <div
          className={
            showSidebar ? styling.mainSection : styling.mainSectionAddition
          }
        >
          <div
            className={
              showSidebar ? styling.mainNavbar : styling.mainNavbarAddition
            }
          >
            <Navbar toggleSidebar={toggleSidebar} showSidebar={showSidebar} />
          </div>

          <div className={styling.multipleComponents}>
            <ActiveComponent />
          </div>
        </div>
      </div>
      {showAddChannel ? <AddChannel toggleChannel={toggleAddChannel} /> : null}
    </>
  );
}

export default Dashboard;
